import { IButtonConfig, IButtonConfigClickHandler } from '../../components/list-view/list-view-button-config.model';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import { DrawerComponentLiaisonBase } from '../drawers/drawer-base-classes';
import { StructureButtonConfigClickHandlerBase } from './button-config-click-handler-base';
import { AccessibilityHelper } from '../../accessibility.helper';
import { IListItem, IListItemManager } from '../../interfaces/ilist-item.interface';
import { FOLDER, FORM_INSTANCE, VIEW } from '../../../views/site/structure/structure.extras';
import { IDrawerComponentLiaison } from '../../interfaces/idrawer-component-liaison';
import { FormInstance } from '../site-content/form-instance.model';
import { Folder } from '../site-content/folder.model';
import { UtilityHelper } from '../../utility.helper';
import { FolderDetailsComponent } from '../../components/folder-details/folder-details.component';
import { FormInstanceDetailsComponent } from '../../components/form-instance-details/form-instance-details.component';
import { RoleViewerComponent } from '../../components/role-viewer/role-viewer.component';
import { ToggleFavoriteComponent } from '../../components/toggle-favorite/toggle-favorite.component';
import { RolesWrapper } from '../../models/roles-wrapper.model';
import { Role } from '../../models/role.model';
import { FolderPropertiesDrawerComponentLiaison, FormInstancePropertiesDrawerComponentLiaison } from './drawer-classes';

/*
export class FolderPropertiesDrawerComponentLiaison extends DrawerComponentLiaisonBase implements IDrawerComponentLiaison {
    public constructor(private structureComponent: StructureComponent, private originalFolder: Folder) {
        super();

        this.initializationHasCompleted();
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-folder-details';
    }

    public drawerComponentInitialized(drawerComponentParam: any): void {
        let drawerComponent: FolderDetailsComponent = <FolderDetailsComponent>drawerComponentParam;

        // Set the drawer's input value(s).
        drawerComponent.folder = this.originalFolder;
        drawerComponent.mode = this.structureComponent.DetailsMode;

        // Listen for the component's outputs.
        //(save) = "this.saveFolder($event)"
        drawerComponent.save.subscribe(updatedFolder => {
            this.saveFolder(updatedFolder);

            this.structureComponent.DrawerComponentLiaison = null;
        });

        // (workflowStateUpdate) = "this.updateWorkflowState($event)"
        drawerComponent.workflowStateUpdate.subscribe(updatedFolder => {
            this.updateWorkflowState(updatedFolder);
        });

        // (delete) = "this.deleteEntity($event)"
        drawerComponent.delete.subscribe(folderToDelete => {
            this.deleteFolder(folderToDelete);
        })

        //(close) = "this.deselectSelected()"
        drawerComponent.close.subscribe(naEvent => {
            this.structureComponent.deselectSelected();

            this.structureComponent.DrawerComponentLiaison = null;
        });
    }

    // Helper methods.
    private saveFolder(folder: Folder): void {
        this.structureComponent.TreeIsStale = false;
        this.structureComponent.FolderService.update(folder).then(response => {
            this.structureComponent.SelectedFolder = response;
            IListItemManager.findAndUpdateFrom(this.structureComponent.ListItems, this.structureComponent.SelectedFolder);
            UtilityHelper.findAndAssignFrom(this.structureComponent.CurrentFolder.childFolders, this.structureComponent.SelectedFolder);
            this.structureComponent.forceTreeRedraw();
            this.structureComponent.deselectSelected();
        });
    }

    private updateWorkflowState(folder: Folder): void {
        this.structureComponent.TreeIsStale = false;
        this.structureComponent.FolderService.transitionFolder(folder).then(response => {
            this.structureComponent.SelectedFolder = response;
            IListItemManager.findAndUpdateFrom(this.structureComponent.ListItems, this.structureComponent.SelectedFolder);
            UtilityHelper.findAndAssignFrom(this.structureComponent.CurrentFolder.childFolders, this.structureComponent.SelectedFolder);
            this.structureComponent.forceTreeRedraw();
            this.structureComponent.deselectSelected();
        });
    }

    private deleteFolder(folder: Folder): void {
        this.structureComponent.deleteOnConfirm("Folder", () => {
            let url: string = `/site/${this.structureComponent.site.id}/structure/${folder.parentFolderId}`;
            this.structureComponent.FolderService.delete(folder.id).then(x => {
                let newList = this.structureComponent.ListItems.filter(item => {
                    return item.getId() !== folder.id;
                });
                this.structureComponent.ListItems = newList;
                this.structureComponent.SelectedFolder = null;

                // In case the folder tree is
                // being shown, force it to redraw.
                this.structureComponent.forceTreeRedraw();
            });
        });
    }

}
export class FormInstancePropertiesDrawerComponentLiaison extends DrawerComponentLiaisonBase implements IDrawerComponentLiaison {
    public constructor(private structureComponent: StructureComponent, private originalFormInstance: FormInstance) {
        super();

        this.initializationHasCompleted();
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-form-instance-details';
    }

    public drawerComponentInitialized(drawerComponentParam: any): void {
        let drawerComponent: FormInstanceDetailsComponent = <FormInstanceDetailsComponent>drawerComponentParam;

        // Set the drawer's input value(s).
        drawerComponent.formInstance = this.originalFormInstance;

        // Listen for the component's outputs.
        // save()
        drawerComponent.save.subscribe(updatedFormInstance => {
            this.saveFormInstance(updatedFormInstance);

            this.structureComponent.DrawerComponentLiaison = null;
        });

        // transition()
        drawerComponent.transition.subscribe(formInstance => {
            this.transitionFormInstance(formInstance);
        });

        // delete()
        drawerComponent.delete.subscribe(formInstance => {
            this.deleteFormInstance(formInstance);
        });

        // close()
        drawerComponent.close.subscribe(naEvent => {
            this.structureComponent.deselectSelected();

            this.structureComponent.DrawerComponentLiaison = null;
        });
    }

    // Helper methods.
    private saveFormInstance(updatedFormInstance: FormInstance): void {
        this.structureComponent.FormInstanceService.save(updatedFormInstance).then(response => {
            this.structureComponent.SelectedFormInstance = response;
            IListItemManager.findAndUpdateFrom(this.structureComponent.ListItems, this.structureComponent.SelectedFormInstance);
            this.structureComponent.deselectSelected();
        });
    }

    private transitionFormInstance(formInstance: FormInstance): void {
        this.structureComponent.FormInstanceService.transitionWorkflowState(formInstance).then(response => {
            this.structureComponent.SelectedFormInstance = response;
            IListItemManager.findAndUpdateFrom(this.structureComponent.ListItems, this.structureComponent.SelectedFormInstance);
            this.structureComponent.deselectSelected();
        });
    }

    private deleteFormInstance(formInstance: FormInstance): void {
        let url: string = this.structureComponent.returnPath(); // `/site/${this.site.id}/structure/folder/${formInstance.folderId}`;
        this.structureComponent.Router.navigateByUrl(url).then(x => {
            this.structureComponent.deleteOnConfirm("Form Instance", () => {
                this.structureComponent.FormInstanceService.delete(formInstance.id).then(x => {
                    var formId = formInstance.id; //form.referencedFormInstance == null ? form.id : form.referencedFormInstance.id;
                    var newList = this.structureComponent.ListItems.filter(item => {
                        return item.getId() !== formId;
                    });
                    this.structureComponent.ListItems = newList;
                    this.structureComponent.SelectedFormInstance = null;

                    // In case the folder tree is
                    // being shown, force it to redraw.
                    this.structureComponent.forceTreeRedraw();
                });
            })
        });
    }

}
*/

// Define handlers for the buttons displayed above each item, e.g. each folder or form instance.
export class EditStructureItemPropertiesClickHandler extends StructureButtonConfigClickHandlerBase {
    // Properties.
    private drawerComponentLiaison: IDrawerComponentLiaison = null;

    // Constructor.
    public constructor(structureComponent: StructureComponent) {
        super(structureComponent);
    }

    public handleButtonClick(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        // Note:  the following method call should be performed by my caller before call this method,
        //        but it does not hurt to include this call here prior to executing any button config logic.

        this.handlePreButtonClick();

        this.doHandleButtonClick(contextItem);
    }

    // Helper methods.
    private doHandleButtonClick(contextItem: any): void {
        this.structureComponent.DetailsMode = VIEW;
        this.structureComponent.SelectedFormInstance = null;
        this.structureComponent.SelectedFolder = null;
        //this.rolesTargetFolder = null; // PAUL:  CAN THIS BE REMOVED???
        //this.selectedItem = evt; // Not used.
        //let item: IListItem = eventData.item;
        let item: IListItem = contextItem;

        if (item.getType() == FOLDER) {
            var folderId: number = item.getId();

            // Note:  the following call to getFolderWithCallback() cannot be used at this time
            //        as class FolderFormInstanceTree does not contain a folder's current workflow state.
            // this.treeManager.getFolderWithCallback(folderId, this.doOnDetailsFolderRetrievedArrowFunction);

            this.structureComponent.FolderService.get(folderId).then(f => {
                this.structureComponent.SelectedFolder = f;
                this.drawerComponentLiaison = new FolderPropertiesDrawerComponentLiaison(this.structureComponent, <Folder>f);
                this.structureComponent.DrawerComponentLiaison = this.drawerComponentLiaison;

                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
            });
        }
        else if (item.getType() == FORM_INSTANCE) {
            var formInstanceId: number = item.getId();

            // Note:  the following call to getFormInstanceWithCallback() cannot be used at this time
            //        as class FolderFormInstanceTree does not contain a form instance's current workflow state.
            // this.treeManager.getFormInstanceWithCallback(this.currentFolder.id, formInstanceId, this.doOnDetailsFormInstanceRetrievedArrowFunction);

            this.structureComponent.FormInstanceService.get(formInstanceId).then(f => {
                this.structureComponent.SelectedFormInstance = f;
                this.drawerComponentLiaison = new FormInstancePropertiesDrawerComponentLiaison(this.structureComponent, <FormInstance>f);
                this.structureComponent.DrawerComponentLiaison = this.drawerComponentLiaison;

                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
            });
        }
    }


}

export class ViewStructureItemPropertiesClickHandler extends StructureButtonConfigClickHandlerBase {
    // Properties.
    private drawerComponentLiaison: IDrawerComponentLiaison = null;

    // Constructor.
    public constructor(structureComponent: StructureComponent) {
        super(structureComponent);
    }

    public handleButtonClick(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        this.handlePreButtonClick();
        this.doHandleButtonClick(contextItem);
    }

    // Helper methods.
    private doHandleButtonClick(contextItem: any): void {
        this.structureComponent.DetailsMode = VIEW;
        this.structureComponent.SelectedFormInstance = null;
        let item: IListItem = contextItem;

        var formInstanceId: number = item.getId();
        this.structureComponent.FormInstanceService.get(formInstanceId).then(f => {
            f.canEdit = false;
            this.structureComponent.SelectedFormInstance = f;
            this.drawerComponentLiaison = new FormInstancePropertiesDrawerComponentLiaison(this.structureComponent, <FormInstance>f);
            this.structureComponent.DrawerComponentLiaison = this.drawerComponentLiaison;
            AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');
        });
    }
}

/*
export class EditStructureRolesDrawerComponentLiaison extends DrawerComponentLiaisonBase implements IDrawerComponentLiaison {
    // Properties.
    // Note:  the following properties were moved out of class StructureComponent.
    private roleMembersAreInherited: boolean;
    private membersAreInheritedFromSiteLevel: boolean;
    private rolesWrapper: RolesWrapper;
    private rolesTargetFolder: Folder;
    private selectedFolderRoles: Role[];

    // Constructor.
    public constructor() {
        super();
    }

    // Getter method(s).
    public get RolesTargetFolder(): Folder {
        return this.rolesTargetFolder;
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-role-viewer';
    }
}
*/

export class EditStructureRolesClickHandler extends StructureButtonConfigClickHandlerBase implements IDrawerComponentLiaison {
    // Properties.
    // Note:  the following properties were moved out of class StructureComponent.
    private roleMembersAreInherited: boolean;
    private membersAreInheritedFromSiteLevel: boolean;
    private rolesWrapper: RolesWrapper;
    private rolesTargetFolder: Folder;
    private selectedFolderRoles: Role[];

    // Constructor.
    public constructor(structureComponent: StructureComponent) {
        super(structureComponent);
    }

    // Getter method(s).
    public get RolesTargetFolder(): Folder {
        return this.rolesTargetFolder;
    }

    // Implement handlerButtonClick().
    public handleButtonClick(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        // Note:  the following method call should be performed by my caller before call this method,
        //        but it does not hurt to include this call here prior to executing any button config logic.
        this.handlePreButtonClick();

        this.doOnRoles(buttonConfig, eventData, contextItem);

        if (contextItem != null) {
            this.structureComponent.DrawerComponentLiaison = this;
            //this.structureComponent.DrawerComponentLiaison = new EditStructureRolesDrawerComponentLiaison();
        }
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-role-viewer';
    }

    // Implement IDrawerComponentLiaison.drawerComponentInitialized().
    public drawerComponentInitialized(drawerComponentParam: any): void {
        let drawerComponent: RoleViewerComponent = <RoleViewerComponent>drawerComponentParam;

        // Set the drawer's input values.
        drawerComponent.roles = this.selectedFolderRoles;
        drawerComponent.folderOrSitelevel = 'folder';
        drawerComponent.membersAreInherited = this.roleMembersAreInherited;
        drawerComponent.enableInheritanceControlButton = this.structureComponent.userCanControlPermissionsInheritance(this.structureComponent.RolesTargetFolder);
        drawerComponent.rolesWrapper = this.rolesWrapper;
        drawerComponent.folderId = this.rolesTargetFolder.id;
        drawerComponent.siteId = this.structureComponent.CurrentFolder.dataCollectionId;
        drawerComponent.folder = this.rolesTargetFolder;
        drawerComponent.title = this.rolesTargetFolder.name;

        // Handle component outputs.
        // Note:  can we move more of the StructureComponent code for roles into this class?
        drawerComponent.close.subscribe(event => {
            // PAUL:  DISCUSS THE FOLLOWING IF BLOCK WITH PAUL.
            if ((this.rolesTargetFolder != null) && (this.structureComponent.ViewAndManageRolesButtonConfig != null)) {
                this.structureComponent.ViewAndManageRolesButtonConfig.updateSelfManagedFolders(this.rolesTargetFolder);
            }

            // PAUL NOTE:  DISCUSS THE FOLLOWING LINE WITH PAUL.
            //this.structureComponent.deselectRolesTargetFolder(event);

            this.structureComponent.DrawerComponentLiaison = null;
        });
    }
    public drawerComponentDestroyed(drawerComponentParam: any): void {
        // NOTE:  THIS METHOD IS A NOOP BY DESIGN.
    }

    // Helper methods.
    public doOnRoles(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        //this.structureComponent.doOnRoles(eventData.item);
        this.structureComponent.SelectedFolder = null;
        let childFolders = this.structureComponent.CurrentFolder.childFolders;
        let childFolderIds = childFolders.map(x => { x.id });
        let item: IListItem = eventData.item;

        if ((item != null) &&
            (item.getId != null) &&
            (item.getType() == FOLDER)) {
            //this.rolesTargetFolder = this.currentFolder.childFolders.filter(f => {
            this.rolesTargetFolder = this.structureComponent.CurrentFolder.childFolders.filter(f => {
                let fId = f.id;
                let iId = item.getId();
                return f.id == item.getId();
            })[0];

            // reset the RoleViewer's input properties to ensure a reset
            this.selectedFolderRoles = null;
            this.roleMembersAreInherited = null;

            this.structureComponent.RoleService.getFolderRoles(item.getId()).then(response => {
                this.rolesWrapper = response;
                this.selectedFolderRoles = response.roles;
                this.roleMembersAreInherited = response.membersAreInherited;
                this.membersAreInheritedFromSiteLevel = response.membersAreInheritedFromSiteLevel;
                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');

                this.initializationHasCompleted();
            });
        } else {
            // PAUL NOTE:  DISCUSS THE FOLLOWING COMMENTED OUT LINE WITH PAUL.
            //this.structureComponent.RolesTargetFolder = null;
        }
    }

}

export class ToggleStructureFavoriteClickHandler extends StructureButtonConfigClickHandlerBase {
    public constructor(structureComponent: StructureComponent) {
        super(structureComponent);
    }

    // Implement handleButtonClick.
    public handleButtonClick(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        // Note:  the following method call should be performed by my caller before call this method,
        //        but it does not hurt to include this call here prior to executing any button config logic.
        this.handlePreButtonClick();

        this.doOnFavorite(buttonConfig, eventData, contextItem);

        if (contextItem != null)
            this.structureComponent.DrawerComponentLiaison = this;
    }

    // Implement IDrawerComponentLiaison methods.
    public get HandlesDrawerComponentTag(): string {
        return 'app-toggle-favorite';
    }

    // Implement IDrawerComponentLiaison.drawerComponentInitialized().
    public drawerComponentInitialized(drawerComponentParam: any): void {
        let drawerComponent: ToggleFavoriteComponent = <ToggleFavoriteComponent>drawerComponentParam;

        // Set the drawer's input values.
        drawerComponent.isFavorite = this.structureComponent.IsFavorite;
        drawerComponent.title = this.structureComponent.FavoriteTitle;

        // Handle component outputs.
        // (save)
        drawerComponent.save.subscribe(event => {
            this.structureComponent.saveToggledFavorite(event);

            this.structureComponent.DrawerComponentLiaison = null;
        });

        // (cancel)
        drawerComponent.cancel.subscribe(event => {
            this.structureComponent.hideToggleFavorite();

            this.structureComponent.DrawerComponentLiaison = null;
        });
    }
    public drawerComponentDestroyed(drawerComponentParam: any): void {
        // NOTE:  THIS METHOD IS A NOOP BY DESIGN.
    }

    // Implement helper methods.
    private doOnFavorite(buttonConfig: IButtonConfig, eventData: any, contextItem: any): void {
        //this.structureComponent.doOnFavorite(eventData.item);
        this.structureComponent.DetailsMode = VIEW;
        this.structureComponent.SelectedFormInstance = null;
        this.structureComponent.SelectedFolder = null;
        // PAUL NOTE:  DISCUSS THE FOLLOWING COMMENTED OUT LINE WITH PAUL.
        //this.structureComponent.RolesTargetFolder = null;
        //this.structureComponent.ShowProperties = false;
        //this.structureComponent.ShowToggleFavorite = false;
        let listItem: IListItem = eventData.item;

        if (listItem.getType() == FOLDER) {
            this.structureComponent.FolderService.get(listItem.getId()).then(f => {
                this.structureComponent.SelectedFolder = f;
                //this.structureComponent.ShowToggleFavorite = true;

                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');

                this.initializationHasCompleted();
            });
        } else if (listItem.getType() == FORM_INSTANCE) {
            this.structureComponent.FormInstanceService.get(listItem.getId()).then(f => {
                this.structureComponent.SelectedFormInstance = f;
                //this.showProperties = true;
                //this.structureComponent.ShowToggleFavorite = true;
                AccessibilityHelper.setFocus('#details-drawer-keyboard-focus-div');

                this.initializationHasCompleted();
            });
        }

        return;
    }
}
